<template>
   <div>
      <div class="card">
          <slot></slot>
      </div>
   </div>
</template>

<script>
  export default {
    props: {
      step: {
        default: 'geo'
      }
    },
    components: {
    },
    computed: {
      isNoDemo () {
        return this.$store.getters['order/currentGeoType'].isDirectCount && this.$store.getters['order/geos'].length !== 0
      }
    },
    methods: {
      goDemo () {
        if (this.isNoDemo) {
          return false
        }
        this.$router.push({name: 'demo'})
      }
    }
  }
</script>

<style scoped lang="scss">

  .option {
    height: 48px;
    padding: 8px;
    text-align: center;
    font-size: 1.2em;
    background-color: $color-primary-light;
    flex-grow: 1;
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, .125);
    border-radius: 4px;
  }
  .option-a {
    color: $color-text-grey;
  }

  .option-a.active {
    color: $color-primary;
  }
  .option.active {
    padding-top: 12px;
    height: 52px;
    background-color: $color-background;
    border-bottom: 0;
  }
  .card {
    position: relative;
    display: flex;
    background-color: $color-background;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, .125);
    border-radius: 0 .25rem;
  }
  .box {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .disabled {
    color: $color-border !important;
    cursor: auto !important;
    text-decoration: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/elements/MTab.vue